import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessUserProfile
export interface IUserAccessUserProfile {
  technicalSupport: ICrudOptions;
  userContactDetails: ICrudOptions;
  userPersonalDetails: ICrudOptions;
  userProfileDetails: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_USER_PROFILE_TECHNICAL_SUPPORT
export const _DEFAULT_USER_ACCESS_USER_PROFILE_TECHNICAL_SUPPORT: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_USER_PROFILE_CONTACT_DETAILS
export const _DEFAULT_USER_ACCESS_USER_PROFILE_CONTACT_DETAILS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_USER_PROFILE_PERSONAL_DETAILS
export const _DEFAULT_USER_ACCESS_USER_PROFILE_PERSONAL_DETAILS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_USER_PROFILE_PROFILE_DETAILS
export const _DEFAULT_USER_ACCESS_USER_PROFILE_PROFILE_DETAILS: Readonly<ICrudOptions & Object> = {
  canEdit: false,
  canSubmit: false,
  canView: false,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_USER_PROFILE
export const _DEFAULT_USER_ACCESS_USER_PROFILE: Readonly<IUserAccessUserProfile & Object> = {
  technicalSupport: _DEFAULT_USER_ACCESS_USER_PROFILE_TECHNICAL_SUPPORT,
  userContactDetails: _DEFAULT_USER_ACCESS_USER_PROFILE_CONTACT_DETAILS,
  userPersonalDetails: _DEFAULT_USER_ACCESS_USER_PROFILE_PERSONAL_DETAILS,
  userProfileDetails: _DEFAULT_USER_ACCESS_USER_PROFILE_PERSONAL_DETAILS,
};
//#endregion
